import { QueryClient } from '@tanstack/react-query';

import { isRetryableApiFailure } from './client';

/**
 * Клиент запросов с настройками приложения.
 *
 * Фабрика, а не готовый объект: тесты собирают свой клиент с теми же умолчаниями. В
 * приложении он ровно один — его держит `app/providers.tsx`, потому что общий кэш и есть
 * связь между фичами (AD-A5). Живёт в `shared`, чтобы тесты экранов могли его взять, не
 * импортируя `app`.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Администратор читает списки, которые меняют другие люди из Mini App: полминуты
        // свежести — компромисс между «цифры те же, что у API» (SPEC) и лишними запросами.
        staleTime: 30_000,
        // Повторять стоит только то, что может пройти со второго раза: обрыв сети, 429 и
        // 5xx. На 403 и 404 повтор — это лишний запрос и вдвое более поздний текст ошибки.
        retry: (failureCount, error) => failureCount < 1 && isRetryableApiFailure(error),
        refetchOnWindowFocus: true,
      },
    },
  });
}
